import moment from 'moment'
import createPaginationModule from '../generic/pagination'
import { NOTIFICATIONS_UAP_LOGS_SUGGESTIONS, NOTIFICATION_UAP_LOGS_ALLOWED_SEARCH_INPUTS } from './search-inputs'
import { formatTwilioError } from '@/utils/twilio-status'

// KPT-1035: /uap_logs is SQL-backed and page-number paginated (same envelope
// as the main SMS list), so the bespoke Datastore-cursor module this file
// used to contain is replaced by the shared pagination module. The store
// name and every getter/action path stay identical.
const endpoint = '/user_api/v1/sms_notifications/uap_logs'
const url = (
  process.env.VUE_APP_USER_API_ENDPOINT +
  endpoint
)

function parseSMSItems (item) {
  return {
    id: item.id,
    // fitter_id holds the recipient phone number (shown as Phone Number).
    fitter_id: item.fitter_id,
    // KPT-1035 SAP metadata (null on rows logged before the migration).
    plant: item.plant,
    planner_group: item.planner_group,
    storage_location: item.storage_location,
    work_center: item.work_center,
    country: item.country,
    created: item.created ? moment(item.created).format('lll') : null,
    error_msg: item.error_msg,
    // Derived badge value - the endpoint returns the raw boolean.
    sms_status: item.if_sms_success == null ? null : (item.if_sms_success ? 'sent' : 'failed'),
    // KPT-1117: error code + message shown in the SMS Status badge tooltip
    // instead of a column of their own. Successful sends are written with
    // error_code 0 and an empty message, and rows synced before the code was
    // recorded have none at all, so both must produce no tooltip.
    sms_error: uapErrorDetails(item),
    message: item.sms_msg,
    tracking_num: item.tracking_num
  }
}

function uapErrorDetails (item) {
  // A successful send stores error_code 0 and pre-migration rows carry none at
  // all; both mean "no error", so they are normalized to null and
  // formatTwilioError returns null for them (no tooltip, no "Error 0").
  return formatTwilioError(item.error_code ? item.error_code : null, item.error_msg)
}

export default {
  namespaced: true,
  modules: {
    uapLogsPagination: createPaginationModule(
      {
        endpoint: url,
        mapper: parseSMSItems
      })
  },
  state: {
  },
  getters: {
    searchSuggestionsList (state) {
      return NOTIFICATIONS_UAP_LOGS_SUGGESTIONS
    },
    allowedSearchInputs (state) {
      return NOTIFICATION_UAP_LOGS_ALLOWED_SEARCH_INPUTS
    }
  }
}
